import { define, auto, Record } from 'type-r'
import { store } from '../models/store.js'

@define
export default class View extends Record {
    @auto('') declare selector: string
    
    parse(data?:any) {
        if (data?.el) {
            if (typeof data.el == 'string') {
                data.selector = data.el;
                delete data.el;
            }
        }
        return data;
    }

    get visible() {
        return $(this.el).is(":visible");
    }
    
    get el() {
        if (this.selector)
            return $(this.selector).get(0);
        else
            return null;
    }
}
